export default __webpack_public_path__ + "static/media/rekava-text-navy.419a39f8.svg";